import React, { useEffect, useState } from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api } from "../../lib/api";
import { FileText, Download } from "lucide-react";

export default function Downloads() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/downloads").then((r) => setItems(r.data || [])); }, []);
  return (
    <div>
      <PageHero title="Downloads" subtitle="Membership forms, reports, guidelines and society publications." breadcrumbs={["Home", "Downloads"]} />
      <section className="section container-page">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((d, i) => (
            <FadeUp key={d.id} delay={i * 0.03} className="card-elev p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-xl bg-brand-primary-light text-brand-primary flex items-center justify-center shrink-0"><FileText size={22} /></div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-brand-text">{d.title}</div>
                {d.description && <div className="text-sm text-brand-muted mt-1 line-clamp-2">{d.description}</div>}
                <div className="text-[11px] uppercase tracking-widest text-brand-muted mt-2">{d.category} • {d.file_type}</div>
              </div>
              <a href={d.file_url} target="_blank" rel="noreferrer" className="btn-primary !py-2.5 !px-4 text-sm" data-testid={`download-${d.id}`}><Download size={16} /> Download</a>
            </FadeUp>
          ))}
          {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No files available yet.</div>}
        </div>
      </section>
    </div>
  );
}
